import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useStats } from "react-instantsearch";
import { useSearchLabels } from "./SearchLabelsContext";
const connectStats = (Component: React.ComponentType<any>) => {
  const Stats = props => {
    const $ = _c(3);
    const data = useStats();
    let t0;
    if ($[0] !== data || $[1] !== props) {
      t0 = <Component {...props} {...data} />;
      $[0] = data;
      $[1] = props;
      $[2] = t0;
    } else {
      t0 = $[2];
    }
    return t0;
  };
  return Stats;
};
const MyStats = t0 => {
  const $ = _c(8);
  const {
    nbHits,
    currentPageNumber
  } = t0;
  const labels = useSearchLabels();
  if (!nbHits) {
    let t1;
    if ($[0] !== labels.noResults) {
      t1 = <h2 className="nav-search__stats"><span className="nav-search__stats__text">{labels.noResults}</span></h2>;
      $[0] = labels.noResults;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  const t1 = currentPageNumber || 1;
  let t2;
  if ($[2] !== labels.of || $[3] !== labels.page || $[4] !== labels.results || $[5] !== nbHits || $[6] !== t1) {
    t2 = <h2 className="nav-search__stats"><span className="nav-search__stats__text">{labels.page} {t1} {labels.of} {nbHits}{" "}{labels.results}</span></h2>;
    $[2] = labels.of;
    $[3] = labels.page;
    $[4] = labels.results;
    $[5] = nbHits;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
const CustomStats = connectStats(MyStats);
export default CustomStats;